import { Component, OnInit, OnDestroy } from '@angular/core';
import { VideoService } from 'shared/services/video-service/video.service';
import { VideoSessionStatus } from 'common/common/constants/video-session-status';
import { Chat } from 'common/xislivechat/models/chat';
import { Subscription } from 'rxjs';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { ThemeServiceHelper } from 'common/theme/service.helper';

@Component({
  selector: 'video-chat-call-toast',
  templateUrl: './video-chat-call-toast.component.html',
  styleUrls: ['./video-chat-call-toast.component.scss']
})
export class VideoChatCallToastComponent implements OnInit, OnDestroy {
  public chat: Chat;
  public videoSessionStatus = VideoSessionStatus;
  public workItemTypes = WorkItemTypes;

  private _workItemSubscription: Subscription;

  constructor(private _videoService: VideoService) {}

  get isInitiatedByVisitor() {
    return this.chat.VideoSessionStatus === VideoSessionStatus.InitiatedByVisitor;
  }

  ngOnInit() {
    this._workItemSubscription = this._videoService.observeActiveChat().subscribe(chat => {
      this.chat = chat;
    });
  }

  ngOnDestroy() {
    if (this._workItemSubscription) {
      this._workItemSubscription.unsubscribe();
      this._workItemSubscription = null;
    }
  }

  showVideoCall(): void {
    this._videoService.focusOrOpenVideoWindow(this.chat);
  }

  getThemeClass(itemId): string {
    return ThemeServiceHelper.getCssClass(itemId);
  }

  get showToast(): boolean {
    return this.chat && this.chat.VideoSessionStatus !== VideoSessionStatus.InitiatedByVisitor;
  }
}
